var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.31255 7.93058H2.88371C1.90488 7.93058 1.11112 7.13682 1.11112 6.15799V3.80033C1.11112 2.8215 1.90488 2.02775 2.88371 2.02775H5.31255C5.46776 2.02775 5.5938 1.9017 5.5938 1.74649V1.19788C5.5938 1.04267 5.46776 0.916626 5.31255 0.916626H2.79169C1.25001 0.916626 0 2.16664 0 3.70832V6.25001C0 7.79169 1.25001 9.0417 2.79169 9.0417H5.31255C5.46776 9.0417 5.5938 8.91565 5.5938 8.76044V8.21183C5.5938 8.05662 5.46776 7.93058 5.31255 7.93058Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63343 3.06985L7.86503 4.30146C7.91017 4.3466 7.87823 4.42368 7.81434 4.42368H3.14138C2.9886 4.42368 2.86499 4.54764 2.86499 4.70007V5.25806C2.86499 5.41084 2.98895 5.53445 3.14138 5.53445H7.81434C7.87823 5.53445 7.90983 5.61154 7.86503 5.65668L6.63343 6.88828C6.52405 6.99766 6.52405 7.17475 6.63343 7.28412L7.02336 7.67406C7.13274 7.78343 7.30982 7.78343 7.4192 7.67406L9.91957 5.17369C10.0269 5.06639 10.0269 4.89209 9.91957 4.78479L7.4192 2.28442C7.30982 2.17505 7.13274 2.17505 7.02336 2.28442L6.63343 2.67436C6.52405 2.78373 6.52405 2.96082 6.63343 3.0702V3.06985Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.a7c60943ad13d276cfb1e3ea07d191a4.svg";
export { ForwardRef as ReactComponent };